export default "__VITE_ASSET__86925355__"